module.exports = __webpack_public_path__ + "media/D_hover.9b5adf1d.mp3";